import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import {
  BaseBox,
} from '@docon/docon-ui-library';
import { updateAppState } from 'redux/reducer/app';
import { colors } from 'utilities/colorConfig';
import { useDispatch, useSelector } from 'react-redux';

interface IProps {
  lat?: number;
  lng?: number;
}

declare global {
  interface Window { google: any; initAutocomplete: any }
}

const Root = styled(BaseBox)`
  flex: 1;
  width: 100%;
  height: 200px;
  border-radius: 4px;
  border: 1px solid ${colors.white};
`;

const Map = ({
  lat,
  lng,
  ...props
}: IProps) => {
  const { isGoogleMapScriptLoad } = useSelector(state => state.app);
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const coordinates = {
    lat: lat || 59.95,
    lng: lng || 30.33,
  };

  useEffect(() => {
    if (!isGoogleMapScriptLoad) {
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBuACA0cLDoN_Ae0BoVyW_Gxq0kkl7kXI8&callback=googleMapScriptonLoad&libraries=places';
      script.defer = true;

      (window as any)['googleMapScriptonLoad'] = function () {
        dispatch(updateAppState({ isGoogleMapScriptLoad: true }));
      };

      document.head.appendChild(script);
    }
  }, []);

  useEffect(() => {

    // const script = document.createElement('script');
    // script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBuACA0cLDoN_Ae0BoVyW_Gxq0kkl7kXI8&callback=initAutocomplete&libraries=places';
    // script.defer = true;

    // Attach your callback function to the `window` object
    if (isGoogleMapScriptLoad) {
      const map = new window.google.maps.Map(
        mapRef.current,
        {
          center: coordinates,
          zoom: 11,
          mapTypeId: 'roadmap',
          disableDefaultUI: true,
        },
      );

      new window.google.maps.Marker({
        map,
        position: coordinates,
      });
    }
  }, [isGoogleMapScriptLoad]);

  return (
    <Root id='googleMap' ref={mapRef} {...props} />
  );

};

export default styled(Map)``;
